import React, { useContext } from 'react';

import AuthenticationContext from 'context/Authentication/AuthenticationContext';
import SidebarContext from 'context/Sidebar/SidebarContext';

import Navbar from 'components/Navbar/Navbar';

export default function Main(props) {

    const { authenticatedState } = useContext(AuthenticationContext);
    const { sidebarState } = useContext(SidebarContext);

    return (
        <div className={!sidebarState.isShow ? "main" : "main main-full"}>
            <div className="navbar">
                <Navbar />
            </div>
            {authenticatedState.isLogged && (
                <div className="content">
                    {props.children}
                </div>
            )}
        </div>
    )
}
